import React from "react";
import { Spin } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';

function LoadingNavigation({ 
    size = "default", 
    color = '#006940',
    fullscreen = false,
    style = {}
}) {
    if (fullscreen) {
        return (
            <div 
                className="loading-navigation-fullscreen" 
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    ...style
                }}
            >
                <Spin 
                    size="large" 
                    indicator={
                        <Loading3QuartersOutlined 
                            spin 
                            style={{ 
                                color, 
                                fontSize: 40
                            }} 
                        />
                    } 
                />
            </div>
        );
    }

    return (
        <div 
            className="loading-navigation" 
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                ...style
            }}
        >
            <Spin 
                size={size} 
                indicator={
                    <Loading3QuartersOutlined 
                        spin 
                        style={{ 
                            color, 
                            fontSize: size === 'large' ? 24 : 16
                        }} 
                    />
                } 
            />
        </div>
    );
}

export default LoadingNavigation;
